import styled from 'styled-components';

export const Image = styled.img`
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const PlaceholderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;
